module.exports = __webpack_public_path__ + "media/images/fleches_dropdown_white-8c7eaa9e5f0d956afc88694a1f0e1dd5.svg";